<template>
  <div class="page">
    <div class="mobile bg-white padding-xs m_top align-center">
      <img
        src="@/assets/img/index/fzdt/logo.png"
        alt=""
        @click="$router.push('/')"
        style="width: 54px"
      />
      <h1
        class="padding-left-xs text-24 text-bold"
        @click="$router.push('/')"
      >
        法治新乡
      </h1>
    </div>
    <!-- 行政执法监督平台 -->
    <div class="box1">
      <div class="box1-con">
        <img src="@/assets/img/fzwm/xzzfjdpt/qzyjjy.png" alt="" />
        <div class="con padding text-18 margin-top-sm text-white" v-html="qzyjjy">
          <!-- <p>
            为加强和改进行政执法监督工作，畅通人民群众反映行政执法普遍性问题和改进行政执法建议的渠道，体现以人民为中心的执法理念，
            促进规范和保障行政机关严格规范公正文明执法，按照新乡市司法局关于“综合协调、指导监督全市行政执法工作”的工作职责，
            新乡市司法局设立行政执法监督群众意见建议平台，在法治新乡门户网站上开辟专栏，重点听取公民、
            法人和其他组织对行政执法和执法监督工作六个方面的意见建议和反映的问题：一是行政执法机关不作为、乱作为；二是行政执法人员选择性执法、执法不公；
            三是行政执法方式不文明，存在一刀切、暴力执法等现象；
            四是加强行政执法队伍规范化制度化建设、加强行政执法人员培训的意见建议；
            五是指导、监督各地区各部门行政执法工作、推进严格公正文明执法的意见建议；六是推行行政执法公示制度、执法全过程记录制度、重大执法决定法制审核制度的意见建议。
          </p>
          　
          <p>
            我们将对收到的意见建议进行归纳整理、研究分析，建立行政执法意见建议大数据，定期统计分析各部门和县（市）、区的行政执法活动；
            对带有普遍性的问题，我们将进行研究并完善有关制度、机制，进一步改进行政执法监督工作。意见建议涉及特定部门和县（市）、区的，
            我们将转送有关部门和县（市）、区，其中涉及重大问题、重点领域的，将由新乡市司法局法制监督协调科直接跟踪督促，经查证属实、较为典型的问题，
            将予以通报、严肃处理。需要说明的是对于具体行政执法决定不服，能通过复议、诉讼等法定渠道解决的，我们将引导当事人通过法定渠道向有关机关反映，
            平台不予处理。
          </p> -->
        </div>
      </div>
    </div>

    <div class="box2 padding-top-lg">
      <!-- 我要留言 -->
      <img src="@/assets/img/fzwm/xzzfjdpt/wyly.png" alt="" />
      <div
        class="wyly flex justify-between padding-lr-sm padding-tb-xl text-20"
      >
        <div class="left">
          <img src="@/assets/img/fzwm/xzzfjdpt/wxts.png" alt="" />
          <span class="margin-left-xs"
            >温馨提示：请客观提出意见建议，并自觉遵守国家有关法律法规，不得发表违法和不恰当言论。</span
          >
        </div>

        <div class="right hover-pointer p-r">
          <img src="@/assets/img/fzwm/xzzfjdpt/smly.png" alt="" />
          <span> 手机扫码留言</span>
          <div class="p-a padding-sm">
            <!-- <img src="@/assets/img/code.png" alt="" /> -->
            <canvas id="QRCode_canvas"></canvas>
          </div>
        </div>
      </div>

      <!-- 表单开始 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <p class="titP text-30 text-bold">问题归属</p>
        <el-row class="padding-tb-xl">
          <el-col :span="12" :xs="24">
            <el-form-item label="所在地区" prop="dwlx">
              <!-- <el-select
                popper-class="xzzfjdpt"
                v-model="ruleForm.dwlx"
                placeholder="请选择"
              >
                <el-option label="红旗区" value="beijing0"></el-option>
                <el-option label="牧野区" value="beijing10"></el-option>
                <el-option label="卫滨区" value="beijing9"></el-option>
                <el-option label="凤泉区" value="beijing44"></el-option>
                <el-option label="高新区" value="beijing11"></el-option>
                <el-option label="经开区" value="beijing22"></el-option>
                <el-option label="平原新区" value="beijing44"></el-option>
                <el-option label="卫辉市" value="beijing2"></el-option>
                <el-option label="辉县市" value="beijing3"></el-option>
                <el-option label="长垣市" value="beijing1"></el-option>
                <el-option label="新乡县" value="beijing4"></el-option>
                <el-option label="获嘉县" value="beijing5"></el-option>
                <el-option label="原阳县" value="beijing6"></el-option>
                <el-option label="延津县" value="beijing7"></el-option>
                <el-option label="封丘县" value="beijing8"></el-option>
              </el-select> -->
              <el-select
                v-model="ruleForm.dwlx"
                placeholder="请选择"
                popper-class="xzzfjdpt"
              >
                <el-option
                  v-for="item in xzqList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="执法部门" prop="bm">
              <el-select
                v-model="ruleForm.bm"
                placeholder="请选择"
                popper-class="xzzfjdpt"
              >
                <el-option
                  v-for="item in zfbmList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                >
                </el-option>
              </el-select>
              <!-- <el-select
                popper-class="xzzfjdpt"
                v-model="ruleForm.bm"
                placeholder="请选择"
              >
                <el-option
                  label="城市管理局（市城市综合执法局）"
                  value="shanghai"
                ></el-option>
                <el-option label="市场监督管理局" value="beijing"></el-option>
                <el-option label="交通运输局" value="shanghai1"></el-option>
                <el-option label="农业农村局" value="beijing2"></el-option>
                <el-option label="生态环境局" value="shanghai3"></el-option>
                <el-option label="公安局" value="beijing4"></el-option>
                <el-option label="教育局" value="shanghai5"></el-option>
                <el-option label="民政局" value="beijing6"></el-option>
                <el-option label="司法局" value="shanghai7"></el-option>
                <el-option label="财政局" value="beijing8"></el-option>
                <el-option label="体育局" value="shanghai9"></el-option>
                <el-option label="林业局" value="beijing10"></el-option>
                <el-option label="水利局" value="shanghai11"></el-option>
                <el-option label="商务局" value="beijing12"></el-option>
                <el-option label="审计局" value="shanghai13"></el-option>
                <el-option label="统计局" value="beijing14"></el-option>
                <el-option label="档案局" value="shanghai15"></el-option>
                <el-option label="气象局" value="beijing16"></el-option>
                <el-option label="科学技术局" value="beijing17"></el-option>
                <el-option label="应急管理局" value="beijing18"></el-option>
                <el-option label="医疗保障局" value="beijing19"></el-option>
                <el-option label="金融工作局" value="beijing20"></el-option>
                <el-option label="新闻出版局" value="beijing21"></el-option>
                <el-option label="国家保密局" value="beijing22"></el-option>
                <el-option label="密码管理局" value="beijing23"></el-option>
                <el-option label="消防救援支队" value="beijing24"></el-option>
                <el-option label="工业和信息化局" value="beijing25"></el-option>
                <el-option label="民族宗教事务局" value="beijing26"></el-option>
                <el-option label="卫生健康委员会" value="beijing27"></el-option>
                <el-option label="退役军人事务局" value="beijing28"></el-option>
                <el-option label="人民防空办公室" value="beijing29"></el-option>
                <el-option
                  label="互联网信息办公室"
                  value="beijing30"
                ></el-option>
                <el-option
                  label="粮食和物资储备局"
                  value="beijing31"
                ></el-option>
                <el-option
                  label="发展和改革委员会"
                  value="beijing32"
                ></el-option>
                <el-option
                  label="自然资源和规划局"
                  value="beijing33"
                ></el-option>
                <el-option
                  label="住房和城乡建设局"
                  value="beijing34"
                ></el-option>
                <el-option
                  label="住房公积金管理中心"
                  value="beijing35"
                ></el-option>
                <el-option
                  label="事业单位登记管理局"
                  value="beijing36"
                ></el-option>
                <el-option
                  label="文化广电和外事旅游局"
                  value="beijing37"
                ></el-option>
                <el-option
                  label="人力资源和社会保障局"
                  value="beijing38"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>

        <p class="titP text-30 text-bold margin-bottom-lg">问题内容</p>

        <el-form-item class="wtlxItem flexItem" label="问题类型" prop="wtlx">
          <el-checkbox-group v-model="ruleForm.wtlx">
            <el-checkbox
              v-for="(item, index) in wtnrList"
              :key="index"
              :label="item.dictValue"
              :name="item.dictValue"
              >{{ item.dictLabel }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- <el-checkbox-group v-model="ruleForm.wtlx">
            <el-checkbox
              label="行政执法机关不作为、乱作为。"
              name="type"
            ></el-checkbox>
            <el-checkbox
              label="行政执法人员选择性执法、执法不公。"
              name="type"
            ></el-checkbox>
            <el-checkbox
              label="行政执法方式不文明，存在一刀切、暴力执法等现象。"
              name="type"
            ></el-checkbox>
            <el-checkbox
              label="加强行政执法队伍规范化制度化建设、加强行政执法人员培训的意见建议。"
              name="type"
            ></el-checkbox>
            <el-checkbox
              label="指导、监督各地区各部门行政执法工作、推进严格公正文明执法的意见建议。"
              name="type"
            ></el-checkbox>
            <el-checkbox
              label="推行行政执法公示制度、执法全过程记录制度、重大执法决定法制审核制度的意见建议。"
              name="type"
            ></el-checkbox>
          </el-checkbox-group> -->
        </el-form-item>

        <el-form-item class="bt margin-tb" label="标题" prop="bt">
          <el-input v-model="ruleForm.bt" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="正文" prop="zw" class="zw flexItem">
          <el-input
            type="textarea"
            :rows="8"
            resize="none"
            v-model="ruleForm.zw"
            placeholder="请输入正文"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="附件" prop="filePath">
          <hndistfileupload
            v-model="ruleForm.filePath"
            db_table_info="mh_tpxw.file_path.3"
            :fileSize="500"
          ></hndistfileupload>
        </el-form-item> -->
        <el-form-item class="margin-top" label="附件" prop="fj">
          <el-upload
            multiple
            class="upload-demo"
            action="/hndistapi/pub/public_file_upload"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="rar/zip/doc/docx/pdf/jpg/png"
            :file-list="fileList"
            :data="{ db_table_info: db_table_info }"
          >
            <el-button size="small" type="primary" icon="el-icon-upload2"
              >点击上传</el-button
            >
            <div slot="tip" class="el-upload__tip">
              <!-- 支持扩展名: .rar zip .doc .docx .pdf jpg .png -->
            </div>
          </el-upload>
          <!-- <el-upload
            class="upload-demo"
            action=""
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple
            :limit="3"
            :file-list="fileList"
          >
            <el-button size="small" type="primary" icon="el-icon-upload"
              >点击上传</el-button
            >
            <div slot="tip" class="el-upload__tip text-18 text-999">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg .png
            </div>
          </el-upload> -->
        </el-form-item>

        <p class="titP text-30 text-bold margin-tb-lg">主体信息</p>

        <el-form-item label="主体类型" prop="ztlx">
          <!-- <el-select popper-class="xzzfjdpt" v-model="ruleForm.ztlx" placeholder="请选择">
				    <el-option label="公民" value="gm"></el-option>
				    <el-option label="法人或其他组织" value="fr"></el-option>
				  </el-select>
					 -->
          <!-- <el-radio-group v-model="ruleForm.ztlx">
            <el-radio label="gm">公民</el-radio>
            <el-radio label="fr">法人或其他组织</el-radio>
            <el-radio label="nm">匿名</el-radio>
          </el-radio-group> -->
          <el-radio-group v-model="ruleForm.ztlx">
            <el-radio
              :label="item.dictValue"
              v-for="(item, index) in ztlxList"
              :key="index"
              >{{ item.dictLabel }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-row class="padding-top-sm">
          <!-- <el-col :span="12">
						<el-form-item label="主体类型:" prop="ztlx">
						  <el-select popper-class="xzzfjdpt" v-model="ruleForm.ztlx" placeholder="请选择">
						    <el-option label="公民" value="gm"></el-option>
						    <el-option label="法人或其他组织" value="fr"></el-option>
						  </el-select>
						</el-form-item>
					</el-col> -->
          <el-col :span="12" :xs="24">
            <template v-if="ruleForm.ztlx == '1'">
              <el-form-item label="姓  名" prop="xm">
                <el-input
                  v-model="ruleForm.xm"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </template>
            <template v-if="ruleForm.ztlx == '2'">
              <el-form-item label="机构名称" prop="jgmc">
                <el-input
                  v-model="ruleForm.jgmc"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
            </template>
          </el-col>

          <el-col :span="12" :xs="24">
            <template v-if="ruleForm.ztlx == '1'">
              <el-form-item label="公民类型" prop="gmlx">
                <el-select
                  v-model="ruleForm.gmlx"
                  placeholder="请选择"
                  popper-class="xzzfjdpt"
                >
                  <el-option
                    v-for="item in gmlxList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
                <!-- <el-select
                  popper-class="xzzfjdpt"
                  v-model="ruleForm.gmlx"
                  placeholder="请选择"
                >
                  <el-option label="市民" value="ptgm"></el-option>
                  <el-option label="法治督察员" value="gwry1"></el-option>
                  <el-option label="人民监督员" value="ptgm2"></el-option>
                  <el-option label="执法监督员" value="gwry3"></el-option>
                </el-select> -->
              </el-form-item>
            </template>
            <template v-if="ruleForm.ztlx == '2'">
              <el-form-item label="机构类别" prop="jglb">
                <el-select
                  v-model="ruleForm.jglb"
                  placeholder="请选择"
                  popper-class="xzzfjdpt"
                >
                  <el-option
                    v-for="item in jglbList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
                <!-- <el-select
                  popper-class="xzzfjdpt"
                  v-model="ruleForm.jglb"
                  placeholder="请选择"
                >
                  <el-option label="国家机关" value="ptgm"></el-option>
                  <el-option label="事业单位" value="gwry"></el-option>
                  <el-option label="国有企业" value="ptgm1"></el-option>
                  <el-option label="民营企业" value="gwry2"></el-option>
                  <el-option label="其他企业" value="ptgm3"></el-option>
                  <el-option label="社会组织" value="gwry4"></el-option>
                  <el-option label="其他" value="gwry"></el-option>
                </el-select> -->
              </el-form-item>
            </template>
          </el-col>
        </el-row>

        <el-row class="padding-tb">
          <el-col :span="12" :xs="24">
            <template v-if="ruleForm.ztlx == '1'">
              <el-form-item label="身份证号" prop="sfzh">
                <el-input
                  v-model="ruleForm.sfzh"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </template>
            <template v-if="ruleForm.ztlx == '2'">
              <el-form-item label="联系人姓名" prop="lxrxm">
                <el-input
                  v-model="ruleForm.lxrxm"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
            </template>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="手 机 号" prop="sjh">
              <el-input
                v-model="ruleForm.sjh"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- TODO 短信临时关闭 -->
          <!-- <el-col :span="12" :xs="24" v-if="ruleForm.ztlx == '3'">
            <el-form-item class="yzm" label="验 证 码" prop="yzm">
              <el-input v-model="ruleForm.yzm" placeholder="请输入验证码">
                <el-button
                  slot="append"
                  @click="handleClick"
                  :disabled="codeDisabled"
                  clearable
                  >{{ btnCode }}</el-button
                >
              </el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- TODO 短信临时关闭 -->
        <!-- <el-row class="" v-if="ruleForm.ztlx !== '3'">
          <el-col :span="12" :xs="24">
            <el-form-item class="yzm" label="验 证 码" prop="yzm">
              <el-input v-model="ruleForm.yzm" placeholder="请输入验证码">
                <el-button
                  slot="append"
                  @click="handleClick"
                  :disabled="codeDisabled"
                  clearable
                  >{{ btnCode }}</el-button
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-form-item
          class="agreeBox flexItem tc padding-top-xl padding-bottom-sm"
        >
          <el-radio v-model="isAgree" label="1" @input="dialogVisible = true"
            >我已阅读并同意<span
              class="hover-pointer"
              @click="dialogVisible = true"
              >《留言须知》</span
            ></el-radio
          >
        </el-form-item>

        <el-form-item class="btnBox flexItem tc padding-bottom-xl">
          <el-button type="primary" @click="submitForm">提交留言</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Footer />

    <!-- <div class="mobile tc bg-white padding-tb-sm">
			<div>
				<span>关于我们</span> <span class="margin-lr-xs">|</span> <span>联系我们</span>
			</div>
			<div class="padding-tb-xs">版权所有：新乡市司法局</div>
			<div>技术支持：河南数慧信息技术有限公司</div>
			<div class="padding-top-xs">备案编号：豫ICP备2020032394号-3</div>
		</div> -->

    <el-dialog
      title="留言须知"
      :visible.sync="dialogVisible"
      width="700"
      :before-close="handleClose"
    >
      <div v-html="lyxz">
        <!-- <p>
          1.本平台旨在面向公民、法人和其他组织听取以下六个方面的意见建议和反映的问题：
          一是行政执法机关不作为、乱作为；二是行政执法人员选择性执法、执法不公；
          三是行政执法方式不文明，存在一刀切、暴力执法等现象；
          四是加强行政执法队伍规范化制度化建设、加强行政执法人员培训的意见建议；
          五是指导、监督各地区各部门行政执法工作、推进严格公正文明执法的意见建议；六是推行行政执法公示制度、执法全过程记录制度、重大执法决定法制审核制度的意见建议。
        </p>
        <p>
          2.留言时，请您填写个人真实信息，如实反映有关情况，并对其真实性负责。我们将严格控制个人信息知悉范围。
          如您在有关选项中选择不公开个人信息，我们将以匿名的方式转给有关方面。
        </p>
        <p>
          3.请您不要就同一事项反复留言。如您近期已向其他平台或通过其他渠道反映该问题，且相关单位已经受理，
          请不要通过本平台重复反映。对于重复来件，我们将不再进行一一回复，敬请谅解。
        </p>
        <p>
          4.留言时请您严格遵守有关法律法规的规定。不得擅自将回复内容截图发布到互联网上，不得发表违法违规言论。同时，本平台答复意见不作为相关争议、相关诉求的依据。
        </p>
        <p>
          5.如您想反映贪污腐败、违法犯罪、信访以及依法应当通过诉讼、仲裁、行政复议等法定途径解决的事项，请依法依规向纪检监察机关、公安机关、信访部门、司法机关等有关机关提出。
        </p>
        <p>感谢您对我们工作的理解和大力支持！</p> -->
      </div>
      <span slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="handleAgree">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import hndistfileupload from "@/components/upload/index";
import { sendMessage } from "@/apis/login";
import { postZF } from "@/apis/fzwm";
import Footer from "@/components/footer/footer.vue";
import { getCode, select_mh_hint } from "@/apis/index";
import QRCode from "qrcode";
export default {
  components: {
    Footer,
  },
  // head() {
  // 	return {
  // 		meta: [
  // 			{
  // 				name: 'viewport',
  // 				content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
  // 			}
  // 		]
  // 	}
  // },
  data() {
    return {
      fileList: [],
      isAgree: "", //是否同意
      ruleForm: {
        wtlx: [],
        // gmlx: 'ptgm'
        ztlx: "1",
      },
      rules: {
        dwlx: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        bm: [{ required: true, message: "请选择执法部门", trigger: "change" }],
        wtlx: [
          { required: true, message: "请选择问题内容", trigger: "change" },
        ],
        bt: [{ required: true, message: "请输入标题", trigger: "blur" }],
        zw: [{ required: true, message: "请输入正文", trigger: "blur" }],
        // fj: [{required: true, message: '请至少上传一个附件', trigger: 'change'}],
        ztlx: [
          { required: true, message: "请选择主体类型", trigger: "change" },
        ],
        xm: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gmlx: [
          { required: true, message: "请选择公民类型", trigger: "change" },
        ],
        sfzh: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
        // sjh: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        sjh: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3-9][0-9]{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        jgmc: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        jglb: [
          { required: true, message: "请选择机构类别", trigger: "change" },
        ],
        lxrxm: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
      },
      dialogVisible: false,

      btnCode: "获取验证码",
      codeDisabled: false,
      db_table_info: "mh_qzjy.files.3",
      filePath: "",
      xzqList: [],
      zfbmList: [],
      gmlxList: [],
      ztlxList: [],
      jglbList: [],
      wtnrList: [],
      fileArr: [],
			timer: null,
			qzyjjy: null,
			lyxz: null,
    };
  },
  created() {
    this.getSameData("xzqList", "mh_qzyj_szdq"); //  行政区
    this.getSameData("zfbmList", "mh_qzyj_zfbm"); //  执法部门
    this.getSameData("gmlxList", "mh_qzyj_gmlx"); //  公民类型
    this.getSameData("ztlxList", "mh_qzyj_ztlx"); //  主体类型
    this.getSameData("jglbList", "mh_qzyj_jglb"); //  机构类别
    this.getSameData("wtnrList", "mh_qzyj_problem_type"); //  问题内容
  },
  mounted() {
    this.getQRCode();
		this.loadQzyj();
		this.loadLyxz();
  },
  methods: {
		loadQzyj() {//群众意见
			select_mh_hint({
				id: 1
			}).then(res => {
				console.log(res.data)
				this.qzyjjy = res.data.content;
			})
		},
		loadLyxz() {//留言须知
			select_mh_hint({
				id: 2
			}).then(res => {
				console.log(res.data)
				this.lyxz = res.data.content;
			})
		},
    getQRCode() {
      let opts = {
        errorCorrectionLevel: "H", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 0, //二维码留白边距
        width: 140, //宽
        height: 140, //高
        text: "http://www.xxx.com", //二维码内容
        color: {
          dark: "#333333", //前景色
          light: "#fff", //背景色
        },
      };
      let qrUrl = window.location.href; //扫描后跳转的路径
      let msg = document.getElementById("QRCode_canvas");
      QRCode.toCanvas(msg, qrUrl, opts, function (error) {
        if (error) {
          console.log("二维码加载失败", error);
          this.$message.error("二维码加载失败");
        }
      });
    },
    handleChange(file, fileList) {},
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
      //  this.filePath = response.data.filepath;
      console.log(response.data.filepath, "response.data.filepath----");
    },
    getSameData(type, data) {
      let params = {
        dictType: data,
      };
      getCode(params).then((res) => {
        this[type] = res.data;
      });
    },
    // 行政区
    getXzq() {
      let params = {
        dictType: "busi_type",
      };
      getCode(params).then((res) => {
        this.xzqList = res.data;
      });
    },
    // 执法部门
    getZFBM() {},
    // 公民类型
    getGMLX() {},
    // 主体类型
    getZTLX() {},
    // 机构类别
    getJGLB() {},
    // 问题内容
    getWTNR() {},
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.isAgree == "") {
            return this.$message({
              message: "请先阅读留言须知!",
              type: "warning",
            });
          }
          for (var i = 0; i < this.fileList.length; i++) {
            this.fileArr.push(this.fileList[i].response.data.filepath);
          }
          let params = {
            phone: this.ruleForm.sjh,
            v_code_id: this.ruleForm.v_code_id,
            code: this.ruleForm.yzm,
            mh_qzyj_szdq: this.ruleForm.dwlx,
            mh_qzyj_zfbm: this.ruleForm.bm,
            mh_qzyj_problem_type: this.ruleForm.wtlx.toString(),
            title: this.ruleForm.bt,
            content: this.ruleForm.zw,
            files: this.fileArr.toString(),
            mh_qzyj_ztlx: this.ruleForm.ztlx,
            name: this.ruleForm.xm,
            mh_qzyj_gmlx: this.ruleForm.gmlx,
            idcard: this.ruleForm.sfzh,
            mh_qzyj_ztlb: this.ruleForm.jglb,
            jglxr_name: this.ruleForm.lxrxm,
            jg_name: this.ruleForm.jgmc,
            mh_qzyj_jglb: this.ruleForm.jglb,
          };
          postZF(params).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.isAgree = "";
              this.$refs.ruleForm.resetFields();
							this.codeDisabled = false;
							this.btnCode = "获取验证码";
							clearInterval(this.timer);
							this.fileList = [];
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handlePreview() {},

    handleClose() {
      //点击右上角关闭
      console.log(1);
      this.isAgree = "";
      this.dialogVisible = false;
    },
    handleAgree() {
      console.log(2);
      this.isAgree = "1";
      this.dialogVisible = false;
    },
    countDown() {
      //验证码倒计时
      this.codeDisabled = true;
      let that = this,
        time = 60;
      that.timer = setInterval(() => {
        time--;
        that.btnCode = time + " 秒后重发";
        if (time == 0) {
          clearInterval(that.timer);
          this.codeDisabled = false;
          that.btnCode = "获取验证码";
        }
      }, 1000);
    },
    handleClick() {
      //点击获取验证码
      let p_reg = /^1[3-9][0-9]{9}$/; //手机号验证
      let e_reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //邮箱验证

      //手机注册
      if (!p_reg.test(this.ruleForm.sjh))
        return this.$message.error("请输入正确的手机号！");
      sendMessage({
        phone: this.ruleForm.sjh,
        tion: 8, //业务类型： (默认1) 1-注册; 2-忘记密码 3-验证码登录
      }).then((res) => {
        this.$message.success(res.msg);
        this.ruleForm.v_code_id = res.data.v_code_id;
        this.countDown();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  background-color: #f1f8ff;
  min-width: $minWidth;
  @mixin name {
    width: 1240px;
    margin: 0 auto;
  }
  .box1 {
    width: 100%;
    height: 914px;
    background: url("@/assets/img/fzwm/xzzfjdpt/bg.png") no-repeat center top;
    background-size: auto 100%;

    .box1-con {
      @include name;
      padding-top: 250px;
      .con {
        background-color: rgba(214, 229, 255, 0.3);
        border-radius: 10px;
        ::v-deep p {
          text-indent: 36px;
          line-height: 38px;
        }
      }
    }
  }

  .box2 {
    @include name;
    .wyly {
      .left {
        color: #333;
        img {
          width: 26px;
          height: 26px;
          vertical-align: middle;
        }
      }
      .right {
        color: #6395eb;
        > img {
          width: 22px;
          height: 22px;
          position: relative;
          top: -2px;
        }
        .p-a {
          display: none;
          background-color: #fff;
          border-radius: 10px;
          z-index: 9;
          top: 40px;
          box-shadow: 0px 0px 16px 1px #eee;
          img {
            width: 140px;
            height: 140px;
          }
        }
        &:hover {
          .p-a {
            display: block;
          }
        }
      }
    }

    .titP {
      line-height: 30px;
      color: #2347a8;
      padding-left: 12px;
      border-left: 4px solid #2347a8;
    }
  }
}

::v-deep .el-form {
  .el-form-item.is-required {
    position: relative;
    &::before {
      content: "*";
      position: absolute;
      top: 13px;
      // top: 50%;
      // transform: translateY(-50%);
      display: block;
      height: 24px;
      color: $red;
      font-size: 36px;
    }
  }
  .el-form-item__label {
    font-size: 20px;
    color: #333;
    line-height: 50px;
    text-align: justify;
    word-break: break-all;
    text-justify: distribute;
    text-align-last: justify;
    padding-left: 17px;
    &::before {
      // font-size: 36px;
      // position: absolute;
      // top: 8px;
      // left: 0;
      display: none;
    }
  }

  .el-input__inner {
    height: 50px;
    line-height: 50px;
    width: 450px;
    font-size: 18px;
    &::placeholder {
      font-size: 18px;
      color: #999;
    }
  }
  .el-textarea__inner {
    font-size: 18px;
    font-family: "微软雅黑";
    &::placeholder {
      font-size: 18px;
      color: #999;
      font-family: "微软雅黑";
    }
  }
  .bt {
    .el-input__inner {
      width: 100%;
    }
  }
  // 问题类型
  .wtlxItem {
    .el-form-item__label {
      width: 0 !important;
      padding-left: 0;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      margin-top: 65px;
      background-color: #fff;
      padding: 30px 0 30px 65px;
      .el-checkbox {
        display: flex;
        padding: 10px 0;
        align-items: center;
        .el-checkbox__inner {
          width: 24px;
          height: 24px;
        }
        .el-checkbox__label {
          font-size: 18px;
          color: #666666;
          white-space: pre-wrap;
          padding-right: 10px;
        }

        .el-checkbox__inner::after {
          width: 8px;
          height: 13px;
          left: 7px;
        }
      }
    }
  }
  // 附件上传
  .upload-demo {
    .el-button {
      width: 150px;
      height: 50px;
      font-size: 18px;
      margin-right: 20px;
      .el-icon-upload {
        font-size: 22px;
      }
    }
    .el-upload__tip {
      display: inline-block;
    }
  }

  .el-radio-group {
    .el-radio {
      line-height: 50px;
      .el-radio__inner {
        width: 18px;
        height: 18px;
      }
    }
    .el-radio__label {
      font-size: 20px;
    }
  }

  // 验证码
  .yzm {
    .el-input {
      width: 450px;
      position: relative;
      .el-input-group__append {
        right: 5px;
        top: 6px;
        position: absolute;
        width: auto;
        height: 38px;
        line-height: 38px;
        color: #fff;
        font-size: 16px;
        background-color: #1385fa;
        border: none;
        border-radius: 4px;
        text-align: center;
        .el-button--default {
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  .agreeBox {
    .el-radio__inner {
      width: 22px;
      height: 22px;
    }
    .el-radio__label {
      font-size: 22px;
      color: #333;
      span {
        color: #2347a8;
      }
    }
  }
  .btnBox {
    .el-button {
      width: 310px;
      height: 60px;
      font-size: 22px;
      border-radius: 4px;
    }
  }
}

::v-deep .el-dialog__wrapper {
  .el-dialog {
    .el-dialog__body {
      p {
        font-size: 18px;
        text-indent: 36px;
        line-height: 32px;
      }
    }
    .el-dialog__footer {
      .el-button--primary {
        font-size: 18px;
        width: 120px;
      }
    }
  }
}
::v-deep .is-disabled {
  background-color: #999 !important;
}

@import "./mobile.scss";
</style>
<style>
/* .xzzfjdpt {
  .el-select-dropdown__wrap {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        padding: 0 10px;
      }
    }
  }
} */
.xzzfjdpt
  .el-select-dropdown__wrap
  .el-select-dropdown__list
  .el-select-dropdown__item {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  padding: 0 10px;
}

/* @media (max-width: 768px) {
	#app {
			min-width: 100%;
		}
} */
</style>
